export const industries = [
  { id: '1', name: '水産・農林業' },
  { id: '2', name: '鉱業' },
  { id: '3', name: '建設業' },
  { id: '4', name: '食料品' },
  { id: '5', name: '繊維製品' },
  { id: '6', name: 'パルプ・紙' },
  { id: '7', name: '化学' },
  { id: '8', name: '医療品' },
  { id: '9', name: '石油・石炭製品' },
  { id: '10', name: 'ゴム製品' },
  { id: '11', name: 'ガラス・土石製品' },
  { id: '12', name: '鉄鋼' },
  { id: '13', name: '非鉄金属' },
  { id: '14', name: '金属製品' },
  { id: '15', name: '機械' },
  { id: '16', name: '電気機器' },
  { id: '17', name: '輸送用機器' },
  { id: '18', name: '精密機器' },
  { id: '19', name: 'その他製品' },
  { id: '20', name: '電気・ガス業' },
  { id: '21', name: '陸運業' },
  { id: '22', name: '海運業' },
  { id: '23', name: '空運業' },
  { id: '24', name: '倉庫・運輸関連業' },
  { id: '25', name: '情報・通信業' },
  { id: '26', name: '卸売業' },
  { id: '27', name: '小売業' },
  { id: '28', name: '銀行業' },
  { id: '29', name: '証券・商品先物取引業' },
  { id: '30', name: '保険業' },
  { id: '31', name: 'その他金融業' },
  { id: '32', name: '不動産業' },
  { id: '33', name: 'サービス業' },
  { id: '34', name: '教育・学習支援業' },
  { id: '35', name: '医療・福祉' },
  { id: '36', name: '公務' },
];
